import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-directorys',
  templateUrl: './directorys.component.html',
  styleUrls: ['./directorys.component.scss']
})
export class DirectorysComponent implements OnInit {
  data;
  titleActivitie = '';
  NotActivitie = 'You not have activities yet';
  constructor() { }

  ngOnInit() {
  }

  selectCard(num) {
    if (num === 1) {
      this.titleActivitie = 'Sinergyz';
      this.data = [{
        id: 1,
        description: 'Mkt',
        color: "#8A2BE2",
        activity: [
          {
            description: 'Add New Person, Luis Rojas',
            responsable: 'Administrador',
            created: 'Mar, 25 2019 14:55',
            status: 'DONE'
          },
          {
            description: 'Add New Dificult',
            responsable: 'Maria Perez',
            created: 'Mar, 27 2019 12:20',
            status: 'IN PROCESS'
          }
        ]
      },
      {
        id: 2,
        color: "#8A2BE2",
        description: 'Tecnologia',
        activity: [
          {
            description: 'Add New Person, Luis Rojas',
            responsable: 'Administrador',
            created: 'Mar, 25 2019 14:55',
            status: 'DONE'
          },
          {
            description: 'Add New Dificult',
            responsable: 'Maria Perez',
            created: 'Mar, 27 2019 12:20',
            status: 'ADD'
          },
          {
            description: 'Delete New Dificult',
            responsable: 'Luis Rodriguez',
            created: 'Mar, 27 2019 12:20',
            status: 'DELETE'
          },
          {
            description: 'Add New Solution',
            responsable: 'Luis Rodriguez',
            created: 'Mar, 27 2019 12:20',
            status: 'ADD'
          }
        ]

      }
      ];
      this.NotActivitie = '';
    } else if (num === 2) {
      this.titleActivitie = '+Complay';
      this.NotActivitie = 'You not have activities yet'
    } else {

    }
  }

}
